export function formatTehranPersianDate(date?: string, showTime = true) {
  if (!date) {
    return;
  }
  const d = new Date(date);

  const datePart = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);

  const timePart = new Intl.DateTimeFormat('fa-IR', {
    timeZone: 'Asia/Tehran',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);

  return showTime ? `${datePart} • ${timePart}` : `${datePart}`;
}
